import { Link } from "react-router-dom";
import { seoSections } from "@/mocks/categories";

export default function SeoContent() {
  const { whatIs, howItWorks, benefits } = seoSections;

  return (
    <>
      <section className="w-full px-6 md:px-10 py-16 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div>
              <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-5">
                hoobuy spreadsheet
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-6">
                {whatIs.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
                {whatIs.content}
              </p>
              <Link
                to="/artigo/guia-completo-hoobuy-spreadsheet"
                className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Ler guia completo
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="bg-accent-500/10 rounded-2xl p-8 md:p-10 border border-accent-200/30">
              <div className="mb-6">
                <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider">
                  HOOBUY SPREADSHEET
                </span>
              </div>
              <p className="text-lg md:text-xl font-heading font-medium text-foreground-800 leading-relaxed italic">
                "O Hoobuy Spreadsheet é a forma mais rápida de encontrar
                produtos baratos, comparar preços e comprar diretamente através
                de agentes confiáveis na China."
              </p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center">
                  <span className="text-accent-700 font-semibold text-sm">✓</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">Equipe Hoobuy</p>
                  <p className="text-xs text-foreground-500">Atualizado em Junho 2026</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100/50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-3">
              Passo a Passo
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              {howItWorks.title}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {howItWorks.steps.map((step, idx) => (
              <div
                key={step.step}
                className="relative bg-background-50 border border-background-200/60 rounded-xl p-6 md:p-7"
              >
                <span className="text-5xl font-heading font-bold text-background-200 absolute top-4 right-6">
                  {step.step}
                </span>
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                  <i className={`text-primary-500 text-lg ${
                    idx === 0 ? "ri-search-eye-line" :
                    idx === 1 ? "ri-file-copy-line" :
                    idx === 2 ? "ri-shopping-bag-3-line" :
                    "ri-home-4-line"
                  }`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{step.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-6 md:px-10 py-16 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs font-semibold text-accent-500 uppercase tracking-widest mb-3">
              Benefícios
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
              {benefits.title}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {benefits.items.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-100/70 border border-background-200/60 rounded-xl p-6 md:p-7 hover:border-primary-200/50 transition-all"
              >
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className={`text-accent-600 text-lg ${
                    idx === 0 ? "ri-money-dollar-circle-line" :
                    idx === 1 ? "ri-scales-3-line" :
                    idx === 2 ? "ri-star-line" :
                    "ri-refresh-line"
                  }`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}